<template>
  <div class="liu" v-wechat-title="'身份认证'">
    <camera ref="camera" @getImgInfo="getImgInfo" />
    <div>
      <div class="color-f-bg">
        <div class="say-color page-padding-l-r padding-t-10 padding-b-10 title-5">
          请拍摄本人的身份证证件
        </div>
        <div class="flex say-color title-5">
          <div class="flex-1 align-center">
            <div @click="$refs.camera.imgClick('renXiang')">
              <img :src="renXiang.base64" class="idCardStyle" v-if="renXiangImgShow" />
              <svg-icon v-else icon-class="authenticate-headshot" class-name="idCardStyle"></svg-icon>
            </div>
            <div class="padding-t-10">人像面</div>
          </div>
          <div class="flex-1 align-center">
            <div @click="$refs.camera.imgClick('guoHui')">
              <img :src="guoHui.base64" class="idCardStyle" v-if="guoHuiImgShow" />
              <svg-icon v-else icon-class="authenticate-emblem" class-name="idCardStyle"></svg-icon>
            </div>
            <div class="padding-t-10">国徽面</div>
          </div>
        </div>
      </div>
      <div class="padding-t-10 padding-b-10 page-padding-l-r">
        <mt-button type="primary" size="large" :disabled="renXiangImgShow && guoHuiImgShow ? false : true"
          @click="submitData">提交</mt-button>
      </div>
    </div>
  </div>
</template>

<script>
/* global wx */

import camera from '@/components/camera.vue';
import SvgIcon from '@/components/SvgIcon';
import { UploadIdCardImg } from '@/api/weChat.js';
import { CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { upLoadImg } from '@/utils/utils.js';

export default {
  name: 'UpdateIdCard',
  components: { camera, SvgIcon },
  data() {
    return {
      // 身份证人像面
      renXiang: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 身份证国徽面
      guoHui: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 按钮当前的状态
      btnStatus: 1,
      // 身份信息
      formData: {
        idCardName: '',
        idCardNum: '',
      },
      token: '',
      mobile: '',
      product: '',
      renXiangImgShow: false,
      guoHuiImgShow: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.formData.idCardName = this.$route.query.idCardName;
      this.formData.idCardNum = this.$route.query.idCardNum;
      this.token = this.$route.query.token;
      this.mobile = this.$route.query.mobile;
      this.product = this.$route.query.product;
    });
  },
  methods: {
    // 返回的图片信息
    getImgInfo(info) {
      this[info.type] = info;
      upLoadImg(
        info.blob,
        info.base64,
        info.type,
        this.mobile,
        yes => {
          if (yes.code === 0) {
            if (info.type === 'renXiang') {
              this.renXiangImgShow = true;
              this.renXiang.webUrl = yes.data;
            }
            if (info.type === 'guoHui') {
              this.guoHuiImgShow = true;
              this.guoHui.webUrl = yes.data;
            }
          } else {
            this.resetCameraInfo(info.type);
          }
        },
        no => {
          this.resetCameraInfo(info.type);
        }
      );
    },
    // 提交数据
    submitData() {
      CusLoadingOpen();
      UploadIdCardImg({
        idcardFrontUrl: this.renXiang.webUrl,
        idCardBackUrl: this.guoHui.webUrl,
      })
        .then(res => {
          CusLoadingClose();
          if (res.code === 0) {
            wx.miniProgram.navigateBack();
          } else {
            CusAlert(res.msg, () => wx.miniProgram.navigateBack());
          }
        })
        .catch(() => {
          CusLoadingClose();
        });
    },
    // 重新拍照
    resetCameraInfo(name, staus = 1) {
      this[name].base64 = '';
      this[name].fileUrl = '';
      this[name].webUrl = '';
      this.btnStatus = staus;
      this.renXiangImgShow = false;
      this.guoHuiImgShow = false;
    },
  },
};
</script>
